import { Component, OnInit } from '@angular/core';
import { LogService } from '@app/_shared/log.service';

@Component({
  selector: 'app-university',
  templateUrl: './university.component.html',
  styleUrls: ['./university.component.less']
})
export class UniversityComponent implements OnInit {

  public routeVal = '';
  receiveVal($event){
    this.routeVal = $event;
  }

  constructor(private eventService: LogService) { }

  public newData = ''
  ngOnInit(): void {
    this.eventService.on<string>().subscribe(
      data => {
        this.newData = data
        this.routeVal = this.newData
        console.log(this.newData +"final")
      }
    )
  }

}
